import Model from '@/lib/data/Model';
import NaicsPrediction from './NaicsPrediction';

class Address extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'customer_id',
        'industry_type',
        'industry_id',
        'short_name',
        'street1',
        'street2',
        'city',
        'state',
        'district',
        'country',
        'postal_code',
        {
            name: 'latitude',
            type: 'float',
        },
        {
            name: 'longitude',
            type: 'float',
        },
        'address_text',
        'organization_id',
        {
            name: 'predictions',
            association: {
                type: 'many',
                model: NaicsPrediction,
            },
        },
        {
            name: 'head_office',
            type: 'bool',
            defaultValue: false,
        },
        'division_id',
        'division_name',
        'location_id',
        'website',
        'phone',
        'trade_group_id',
        'occupation_description_id',
        'building_value',
        'plant_value',
        'stock_value',
        'other_value',
        'gross_profit_value',
        'indemnity_period',
        'financial_comment',
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    get addressType() {
        switch (this.address_type) {
            case 0:
                return 'Visit';
            case 2:
                return 'Invoice';
            case 4:
                return 'Shipping';
            default:
                return null;
        }
    }

    get addressTextFromData() {
        return `${this.street1},${this.street2 ? this.street2 : ''} ${this.city} ${
            this.district
        }, ${this.country}`;
    }

    api = [
        {
            name: 'remove',
            method: 'DELETE',
            url: '/customer/address/delete',
            params: ['id', 'customer_id'],
        },
        {
            name: 'save',
            method: 'POST',
            url: '/customer/address/save',
        },
        {
            name: 'checkRelativity',
            url: '/customer/relativity/search',
            params: ['customer_name', 'address_text', 'country', 'city', 'state'],
        },
    ];
}

export default Address;
